import {animate, animateChild, query, state, style, transition, trigger} from "@angular/animations";

export const slideInLeft = trigger("slideInLeft", [
  transition(":enter", [
    style({
      transform: "translateX(-100%)"
    }),
    animate(
      "500ms",
      style({
        transform: "translateX(0)",
        display: "flex"
      })
    )
  ]),
  transition(":leave", [
    style({
      transform: "translateX(0)",
      display: "flex"
    }),
    animate(
      "500ms",
      style({
        transform: "translateX(-100%)"
      })
    )
  ])
]);

export const fade = trigger('fade', [
  transition(':enter', [
    style({opacity: 0}),
    animate('100ms', style({opacity: 1})),
  ]),
  transition(':leave', [
    animate('100ms', style({opacity: 0}))
  ])
]);

export const flyInOut = trigger('flyInOut', [
  state('in', style({transform: 'translateX(0)'})),
  transition('void => *', [
    style({transform: 'translateX(-100%)'}),
    animate(500)
  ]),
  transition('* => void', [
    animate(500, style({transform: 'translateX(100%)'}))
  ])
]);

export const childContainerAnimate = trigger('container', [
  transition(':enter, :leave', [
    query('@*', animateChild()),
  ]),
]);
